<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      <span class="badge bg-primary rounded-pill bx-pull-right font-size-12">
        Total
      </span>
      Dispositivos de hogar
    </h5>
    <div class="card-body">
      <div class="row">
        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'listadoDhs',
              query: { con_cliente: 1 }
            }"
            title="Asigandos"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-success bg-gradient"
                :class="asignados <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="asignados"
              >
                {{ asignadosFormato }}
              </div>
            </div>
            <div class="text-success text-truncate w-100">
              Asignados
            </div>
          </router-link>
        </div>
        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'listadoDhs',
              query: { con_cliente: 0 }
            }"
            title="Sin asignar"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-warning bg-gradient"
                :class="sin_asignar <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="sin_asignar"
              >
                {{ sinAsignarFormato }}
              </div>
            </div>
            <div class="text-warning text-truncate w-100">
              Sin asignar
            </div>
          </router-link>
        </div>
        <div class="col-4 text-center">
          <router-link
            :to="{ name: 'listadoDhs' }"
            title="Dispositivos de hogar"
          >
            <div class="avatar mx-auto">
              <div class="avatar-title rounded-circle bg-primary bg-gradient font-size-24">
                <i class="mdi mdi-router-wireless"></i>
              </div>
            </div>
            <div class="text-truncate w-100">
              DHs
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DhSrv from '@/services/DhSrv.js'

export default {
  name: 'WDispositivosHogar',
  data() {
    return {
      asignados:   sessionStorage.getItem('argusblack.wdhs.asignados')    || 0,
      sin_asignar: sessionStorage.getItem('argusblack.wdhs.sin_asignar') || 0,
      intervals: {
        actualizacion: null
      }
    }
  },
  created() {
    var self = this

    this.actualizar()
    this.intervals.actualizacion = setInterval(function() {
      self.actualizar()
    }, 60000)
  },
  computed: {
    asignadosFormato: function() {
      return this.asignados <= 9999 ? this.asignados : '999+'
    },
    sinAsignarFormato: function() {
      return this.sin_asignar <= 9999 ? this.sin_asignar : '999+'
    }
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    actualizar() {
      var self = this
      let params = { mes_actual: true }
      DhSrv.nAsignados(params).then(response => {
        self.asignados = response.data
        sessionStorage.setItem('argusblack.wdhs.asignados', self.asignados)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })

      DhSrv.nSinAsignar(params).then(response => {
        self.sin_asignar = response.data
        sessionStorage.setItem('argusblack.wdhs.sin_asignar', self.sin_asignar)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })
    }
  }
}
</script>